// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    HOMEPAGE_PROMOTER_TOP_PROMO_BAR_LOADING() {
      return {
        isLoading: true,
        promoterTopPromoBar: action.promoterTopPromoBar
      };
    },
    HOMEPAGE_PROMOTER_TOP_PROMO_BAR_LOADED() {
      return {
        isLoading: false,
        data: action.promoterTopPromoBar
      };
    },
    HOMEPAGE_PROMOTER_TOP_PROMO_BAR_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.promoterTopPromoBar.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
